(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider

            .state('odeme-success', {
                url: "/:langcode/payment/success/:id?utm_source",
                template: '<payment-success></payment-success>',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    id: {
                        type: 'any',
                        raw: true,
                        value: null,
                        squash: true,
                        dynamic: true
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'payment');
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('payment');
                        return $translate.refresh();
                    }],
                    bankInit: ['$rootScope', '$q', '$transition$', function ($rootScope, $q, $transition$) {
                        var deferred = $q.defer();
                        // Bank integration check
                        if ($rootScope.isTop && window.hasAllowance === 'bank') {
                            $rootScope.isBank = true;
                            var utmSource = $transition$.params().utm_source;
                            var bankSource = null;
                            // Set source based on bank: isbankasi=5, yapikredi=4, akbank=12
                            if (utmSource === 'isbankasi') {
                                bankSource = 5;
                            } else if (utmSource === 'yapikredi') {
                                bankSource = 4;
                            } else if (utmSource === 'akbank') {
                                bankSource = 12;
                            }
                            // Initialize clientData for bank mode
                            if (!$rootScope.clientData)
                                $rootScope.clientData = {
                                    name: null,
                                    surName: null,
                                    phoneNumber: null,
                                    email: null,
                                    ip: null,
                                    source: bankSource

                                }
                        } deferred.resolve();
                        return deferred.promise;
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('odeme-onepage', {
                url: "/:langcode/payment/:code?currency?promo?type?is_commitment?country?city?county?district?level?error",
                templateUrl: 'app/payment/payment-onepage.html',
                controller: 'PaymentOnePageController',
                controllerAs: 'vm',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    code: { type: 'any', raw: true }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'paymentExternal');
                    }],

                    products: ['paymentService', function (paymentService) {
                        return paymentService.getProducts();
                    }],
                    isProduct: ['$transition$', '$location', 'products', 'paymentService', function ($transition$, $location, products, paymentService) {
                        var checkId = false;
                        for (var j = 0; j < products.data.length; j++) {
                            if ($transition$.params().code === products.data[j].code && ($transition$.params().type ? products.data[j].productType === +$transition$.params().type : true)) {
                                paymentService.clearCart();
                                paymentService.addToCart(products.data[j]);
                                checkId = true;
                            }
                        }
                        if (!checkId) {
                            var langKey = window.lang || 'tr';
                            $location.replace().path('/' + langKey + '/404'); //state olunca history'e mevcut sayfay� ekledi�inden browser geri tu�u �al��m�yor b�yle y�nlendirmelerde bu nedenle location.replace
                        }
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('payment');
                        $translatePartialLoader.addPart('factura_address');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            });
        //http://localhost:8080/tr/payment/kira-trink/NDc0Mzg1/facbfe00-9689-49d0-99c4-08d94219ad66
        // .state('odeme-renta', {
        //     url: "/:langcode/payment/kira-trink/:propertyId/:paymentId",
        //     templateUrl: 'app/payment/payment-onepage.html',
        //     controller: 'PaymentOnePageController',
        //     controllerAs: 'vm',
        //     params: {
        //         langcode: {
        //             value: function ($translate) {
        //                 return $translate.use();
        //             }
        //         },
        //         propertyId: { type: 'any', raw: true },
        //         paymentId: { type: 'any', raw: true }
        //     },
        //     lazyLoad: function ($transition$) {
        //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
        //         lazyLoad.inject('ngAnimate');
        //         lazyLoad.load([
        //             "/assets/css/vendor.payment.min.css?v=" + window.appVersion,
        //             "/assets/css/main.payment.min.css?v=" + window.appVersion
        //         ]);
        //         return lazyLoad.load(
        //             {
        //                 serie: false,
        //                 files: [
        //                     "https://www.google.com/recaptcha/api.js?render=6LdqE04cAAAAADAoSM5v54W0wLw6XRQvnaU9tgVS",
        //                     "/assets/js/vendor.payment.min.js?v=" + window.appVersion,
        //                     "/assets/js/main.payment.min.js?v=" + window.appVersion,
        //                 ], insertBefore: '#last_script'
        //             }
        //         );
        //     },
        //     resolve: {
        //
        //         products: ['paymentService', function (paymentService) {
        //             return paymentService.getProducts();
        //         }],
        //         renta: ['paymentService', '$transition$', function (paymentService, $transition$) {
        //             return paymentService.getRenta($transition$.params().propertyId);
        //         }],
        //         payment: ['renta', '$transition$', function (renta, $transition$) {
        //             if (renta && renta.data && renta.data.payments)
        //                 return renta.data.payments.find(pay => pay.id === $transition$.params().paymentId);
        //             else
        //                 return null;
        //         }],
        //         isProduct: ['$location', 'products', 'payment', 'paymentService', function ($location, products, payment, paymentService) {
        //             const productCode = payment.paymentType === 2 ? 'kira-trink-subscription' : 'kira-trink';
        //             var product = products.data.find(product => product.code === productCode);
        //             if (payment && product) {
        //                 paymentService.clearCart();
        //                 product.manuelPrice = payment.amount;
        //                 paymentService.addToCart(product);
        //             }
        //             else {
        //                 var langKey = window.lang || 'tr';
        //                 $location.replace().path('/' + langKey + '/404'); //state olunca history'e mevcut sayfay� ekledi�inden browser geri tu�u �al��m�yor b�yle y�nlendirmelerde bu nedenle location.replace
        //             }
        //         }],
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('payment');
        //             $translatePartialLoader.addPart('factura_address');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // });


    }]);
})();
